import { useState } from "react";
import InputField from "../InputField";
import ModalParent from "./ModalParent";
import { generalObj } from "../../constant/object_types";
import ButtonFrame from "../ButtonFrame";
import { useSelector } from "react-redux";
import { RootState } from "../../redux";
import { useOutletContext } from "react-router-dom";
import { addEditOrganization } from "../../action/generalFunc";
import { toast } from "react-toastify";

const AddOrganizationModal = ({ visible, modalClose, onAdded }:{
    visible: boolean,
    modalClose: () => void,
    onAdded : (val:generalObj) => void
}) => {
    const [formData, setFormData] = useState<generalObj>({
        name: ""
    });

    const account = useSelector((state:RootState) => state.account);
    const {setModalLoading}:{setModalLoading:Function} = useOutletContext(); 

    const submitOrganization = async () => {
        if (!account || formData.name.length === 0) return;
        setModalLoading(true);
        let result = await addEditOrganization(account.token, formData);
        if (result) {
            toast(result.message);
            onAdded(result.data);
        }
        setModalLoading(false);
    }

    return (
        <ModalParent visible={visible}>
            <div className="ViewContainer">
                <div className="input__pop">
                    <h4>Add New Organization</h4>
                    <div>
                        <InputField label={"Organization Name"} inputProp={{value:formData.name}} onTextChange={(evt) => setFormData({...formData, name:evt})} containerStyle={{width:"100%", marginBottom:"20px"}} />
                    </div>

                    <div style={{display:"flex", justifyContent:'space-between', alignItems:'center', marginTop:"60px"}}>
                        <ButtonFrame btn_text="Cancel" btn_style={{padding:"12px 24px", borderRadius:"8px", border:"1px solid #808280", color:"#808280", fontSize:"14px", fontWeight:"600", letterSpacing:"-0.4px"}} onPress={() => modalClose()} />
                        <ButtonFrame btn_text="Submit" btn_style={{padding:"12px 24px", borderRadius:"8px", backgroundColor:"#00983A", color:"#FFF", fontSize:"14px", fontWeight:"600", letterSpacing:"-0.4px"}} onPress={() => submitOrganization()}/>
                    </div>
                </div>
            </div>
        </ModalParent>
    )
}

export default AddOrganizationModal;